import * as React from "react"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import { IconButton, InputAdornment, TextField } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import Grid from "@mui/material/Grid2"
import { Button } from "@mui/material"
import { LoadingBackdropIndeterminate } from "../../LoadingBackdrop"
import { useTrackedLocation } from "../../UserState"
import { useSnackbar } from "notistack"
import { changePaymentAmount, sendPayment } from "./PaymentModalFunctions"
import { emailRegex } from "../../../Constants"

export default function BlockchypLinkPaymentModal({
    open,
    closeModal,
    invoice,
    customer,
    amount
}) {
    const [selectedLocation,] = useTrackedLocation();
    const { enqueueSnackbar } = useSnackbar();
    const [paymentAmount, setPaymentAmount] = React.useState(amount)
    const [checkoutPayingStep, setCheckoutPayingStep] = React.useState(0)
    const [email, setEmail] = React.useState(customer.email)
    const mySendPayment = sendPayment(setCheckoutPayingStep, enqueueSnackbar, closeModal)
    const mychangePaymentAmount = changePaymentAmount(setPaymentAmount, amount)
    const valid_email = Boolean(email.match(emailRegex))

    const submit = (e) => {
        e.preventDefault();
        mySendPayment('BLOCKCHYP-URL', invoice.id, paymentAmount.toFixed(2), selectedLocation.id, { email: email })
    }

    React.useEffect(() => {
        if (open) {
            setPaymentAmount(Math.round(amount * 100) / 100)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [amount, open])

    return (
        (<div>
            <Dialog
                open={open}
                onClose={() => closeModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                maxWidth='xs'
                fullWidth
            >
                <LoadingBackdropIndeterminate
                    open={checkoutPayingStep > 0}
                    text={"Submitting Payment"}
                />
                <form onSubmit={submit}>
                    <DialogTitle>
                        <span style={{ "paddingRight": "24px" }}>BlockChyp Email Payment</span>
                        <IconButton
                            aria-label="close"
                            onClick={() => closeModal(false)}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container direction='column' spacing={2}>
                            <Grid item>
                                <TextField
                                    margin="dense"
                                    id="paymentamount"
                                    label="Payment Amount"
                                    type="number"
                                    fullWidth
                                    variant="standard"
                                    value={paymentAmount.toString()}
                                    onChange={mychangePaymentAmount}
                                    sx={{ minWidth: '125px' }}
                                    slotProps={{
                                        input: {
                                            inputProps: { min: Math.min(0, Math.round(amount * 100) / 100), max: Math.max(0, Math.round(amount * 100) / 100), step: "any" },
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    {<AttachMoneyIcon />}
                                                </InputAdornment>
                                            ),
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item>
                                <TextField
                                    margin="dense"
                                    id="email"
                                    label="Email"
                                    type="email"
                                    variant="filled"
                                    value={email}
                                    fullWidth
                                    onChange={(e) => setEmail(e.target.value)}
                                    sx={{ minWidth: '250px' }}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                            <Grid xs="auto">
                            </Grid>
                            <Grid xs="auto">
                                <Button variant="contained" type="submit" disabled={parseFloat(paymentAmount) === 0 || !valid_email}>
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </form>
            </Dialog>
        </div>)
    );
}
